interface MetricDisplayProps {
  label: string;
  value?: number;
  outOf?: number;
}

export function MetricDisplay({
  label,
  value,
  outOf = 10,
}: MetricDisplayProps) {
  if (value === undefined) {
    return (
      <div className="space-y-1">
        <span className="text-sm text-gray-500">{label}</span>
        <p className="text-lg font-medium text-gray-400">N/A</p>
      </div>
    );
  }

  const percentage = (value / outOf) * 100;

  const getColor = () => {
    if (percentage >= 80) return "text-green-600";
    if (percentage >= 60) return "text-yellow-600";
    return "text-red-600";
  };

  return (
    <div className="space-y-1">
      <span className="text-sm text-gray-500">{label}</span>
      {value ? (
        <p className={`text-lg font-medium ${getColor()}`}>
          {value.toFixed(1)}/{outOf}
        </p>
      ) : (
        <p className="text-lg font-medium text-gray-400">N/A</p>
      )}
    </div>
  );
}
